import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProfilePhotoUploadComponent } from './profile-photo-upload.component';
import {DxButtonModule} from 'devextreme-angular';



@NgModule({
  declarations: [ProfilePhotoUploadComponent],
  imports: [
    CommonModule,
    DxButtonModule
  ],
  exports: [ProfilePhotoUploadComponent]
})
export class ProfilePhotoUploadModule { }
